// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"da3466b7","222":"d61330a2","320":"3d9d970a","725":"231bc6b7","787":"34676305","791":"54385410"}[chunkId] + ".chunk.js";
};